<template>
    <div>
        <b-modal
            id="add-role-popup"
            ref="modal"
            :title="title"
            :hide-header-close="loading"
            size="lg"
            hide-footer
            no-close-on-backdrop
            modal-class="hide-footer"
            no-close-on-esc
            @hidden="onHidden"
        >
            <b-form
                class="role-form-section"
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div id="style-2" class="scrollable">
                    <div class="row custom-model-form">
                        <div class="col-md-6">
                            <b-form-group
                                id="input-group-1"
                                label="Role Title"
                                label-for="role-title"
                            >
                                <b-form-input
                                    id="role-title"
                                    v-model="formData.title"
                                    v-validate="{
                                        required: true,
                                        max: 50,
                                    }"
                                    type="text"
                                    name="title"
                                    :class="{
                                        'is-invalid': errors.has('title'),
                                    }"
                                    autocomplete="no"
                                    placeholder="Enter role title"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col-md-12 scale-type">
                            <h4>Permissions</h4>
                        </div>
                        <div class="col-md-12 permissions-section">
                            <check-box-listing
                                v-model="formData.permissions"
                                :check-box-listing="permissions.insights"
                                checkbox-name="insights"
                                parent-name="Insights"
                                @get-selected="addPermissions"
                            ></check-box-listing>
                            <check-box-listing
                                ref="customer-profile"
                                v-model="formData.permissions"
                                :check-box-listing="
                                    permissions.customerProfiles
                                "
                                checkbox-name="customerprofile"
                                parent-name="Customer Profiles"
                                @get-selected="addPermissions"
                            ></check-box-listing>
                            <check-box-listing
                                ref="configurations"
                                v-model="formData.permissions"
                                :check-box-listing="permissions.configurations"
                                checkbox-name="configurations"
                                parent-name="Configurations"
                                @get-selected="addPermissions"
                            ></check-box-listing>

                            <check-box-listing
                                ref="screening-data"
                                v-model="formData.permissions"
                                :check-box-listing="permissions.screeningData"
                                checkbox-name="screeningData"
                                parent-name="Configurations > Screening Data"
                                @get-selected="addPermissions"
                            ></check-box-listing>

                            <check-box-listing
                                ref="system-user"
                                v-model="formData.permissions"
                                :check-box-listing="permissions.systemUser"
                                checkbox-name="systemUser"
                                parent-name="System User"
                                @get-selected="addPermissions"
                            ></check-box-listing>

                            <check-box-listing
                                ref="system-logs"
                                v-model="formData.permissions"
                                :check-box-listing="permissions.systemLogs"
                                checkbox-name="systemLogs"
                                parent-name="System Logs"
                                @get-selected="addPermissions"
                            ></check-box-listing>

                            <radio-listing
                                :indeterminate="false"
                                :radio-listing="permissions.statusReview"
                                :radio-name="'kyc'"
                                :selected-value="
                                    selectedStatus[0]
                                        ? selectedStatus[0].value
                                        : null
                                "
                                parent-name="KYC Status Review Role"
                                @get-selected="addPermissions"
                            ></radio-listing>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
            <base-toast></base-toast>
        </b-modal>
    </div>
</template>

<script>
import checkBoxListing from '@/components/CheckBoxListing.vue'
import radioListing from '@/components/RadioListing.vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
    components: {
        checkBoxListing,
        radioListing,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            selected: 'maker',
            formData: this.initializeFormData(),
            selectedStatus: '',
            arrayOfPermissions: [],
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'permissions', 'hidePopup']),
        title() {
            return this.selectedItem ? 'Modify Role' : 'Add Role'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, value)
                this.formData.id = value.id
                console.log('selected: ', value.permissions)
                this.arrayOfPermissions = value.permissions
                this.selectedStatus = this.permissions.statusReview.filter(
                    (v) => this.formData.permissions.includes(v.value)
                )
            } else if (this.$refs.modal._isShown) {
                this.$refs.modal.hide()
            } else {
                this.onHidden()
            }
        },

        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > watch

    methods: {
        initializeFormData() {
            return {
                id: '',
                title: '',
                permissions: [],
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (!this.arrayOfPermissions.length) {
                this.$store.commit('setError', 'Permissions are required')
                return
            }
            if (result) {
                try {
                    this.formData.permissions = _.uniq(this.arrayOfPermissions)
                    console.log('permissions: ', this.formData.permissions)
                    delete this.formData.status
                    if (this.formData.id) {
                        await this.$store.dispatch('updateRole', this.formData)
                    } else {
                        await this.$store.dispatch('addRole', this.formData)
                    }
                    console.log('after api call')
                    // Clear form fields
                } catch (error) {
                    console.log(error, 'There is an error on submit')
                }
            }
        },
        addPermissions(value, parentName, allSelected, type) {
            let arr = []
            if (type == 'radio' && typeof value !== 'boolean') {
                arr.push(value)
                _.remove(this.arrayOfPermissions, function (el) {
                    // remove previous kyc status from permissions array
                    return (
                        el == 'maker' ||
                        el == 'checker' ||
                        el == 'approver' ||
                        el === 'unlock-alerts'
                    )
                })
                this.arrayOfPermissions = _.concat(this.arrayOfPermissions, arr)
            }
            if (type == 'checkbox') {
                const per = this.permissions[_.camelCase(parentName)]

                let removePer = _.map(per, 'value')

                removePer = removePer.filter(function (obj) {
                    return !value.includes(obj)
                })

                _.remove(this.arrayOfPermissions, function (n) {
                    return removePer.includes(n)
                })

                this.arrayOfPermissions = _.union(
                    this.arrayOfPermissions,
                    value
                )
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            Object.assign(this.formData, this.initializeFormData())
            this.arrayOfPermissions = []
            this.formData.permissions = []

            this.selectedStatus = ''
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
    },
}
</script>
